module.exports = __webpack_public_path__ + "img/contact.662870fe.png";